import { Button, Flex, HStack, Input, Spacer, Textarea, VStack, Text, Image } from '@chakra-ui/react';
import { Control, useForm, useWatch } from 'react-hook-form';
import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { FaPlus } from 'react-icons/fa6';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { useCreateAgreementPushNotificationMutation } from '@partiu/api/dashboard/hooks.ts';
import { AddModalProps } from '../../types';
import { IAgreementNotification } from '@partiu/api/dashboard/types.ts';

function NotificationCard({ control }: { control: Control }) {
  const { logo } = useTheme();
  const title = useWatch({
    control,
    name: 'title',
  });
  const text = useWatch({
    control,
    name: 'text',
  });

  return (
    <Flex
      dir="row"
      padding={2}
      marginTop={'50px'}
      borderRadius="5%"
      wordBreak="normal"
      overflowWrap="break-word"
      boxShadow="-1px 1px 5px 0px rgba(0,0,0,0.3)"
      width="180px"
      minHeight={50}
    >
      <Image src={logo} width={30} height={30} style={{ objectFit: 'contain' }} />
      <Flex flexDir="column" px={2} justifyContent="flex-start">
        <Text fontSize={11} fontWeight="bold">
          {title || 'Defina um titulo'}
        </Text>
        <Text fontSize={11}>{text || 'Defina um texto'}</Text>
      </Flex>
    </Flex>
  );
}

export function PushNotificationForm({ onClose = () => {}, options }: AddModalProps<IAgreementNotification>) {
  const { register, handleSubmit, control, formState: {errors} } = useForm();
  const mutation = useCreateAgreementPushNotificationMutation(options);

  return (
    <VStack align={'stretch'} justify={'stretch'} spacing={5}>
      <form
        style={{ flex: 1, height: '100%' }}
        onSubmit={handleSubmit((data) => mutation.mutate(data as IAgreementNotification))}
      >
        <VStack height={'100%'} spacing={5}>
          <Labeled label={'Título *'}>
            <Input {...register('title', { required: true, maxLength: {
              message: "Tamanho máximo: 60 caracteres",
              value: 60,
            } })} />
          </Labeled>
          <Labeled label={'Texto *'}>
            <Textarea minHeight={'100px'} {...register('text', { required: true, maxLength: 60 })} />
          </Labeled>
          <Labeled label={'Data de Envio *'}>
            <Input type="datetime-local" {...register('date', { required: true })} />
          </Labeled>
          <Labeled label={'Preview'}>
            <VStack height={'500px'} width={'100%'} position={'relative'}>
              <Image
                src={'/images/phone.png'}
                width={'100%'}
                height={'100%'}
                position={'absolute'}
                objectPosition={'top'}
                objectFit={'contain'}
              />
              <NotificationCard control={control} />
            </VStack>
          </Labeled>
          <HStack width={'100%'} paddingTop={5}>
            <Spacer />
            <Button isLoading={mutation.isLoading} variant="ghost" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              isLoading={mutation.isLoading}
              leftIcon={<FaPlus />}
              type={'submit'}
              variant={'solid'}
              colorScheme={'green'}
            >
              Agendar
            </Button>
          </HStack>
        </VStack>
      </form>
    </VStack>
  );
}
